<!--
/**
 *@author hhy
 *@date 2023年2月9日
 财务管理 对账管理 平台资金流账单
*/
-->
<template>
  <scroll-layout>
    <template #header>
      <div v-if="pageTopButtons.length > 0" class="button-wrap">
        <ykc-search
          ref="YkcSearch"
          :data="searchData"
          :searchForm="searchParams"
          @click="handleSearchConfirm"
          @clean="handleSearchClean"></ykc-search>
      </div>
    </template>
    <div class="motorcade-main-account">
      <ykc-table
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        title="收支账单"
        operateFixedType="right"
        :operateButtons="tableOperateButtons">
        <template #headerButtons>
          <ykc-button
            v-for="(button, index) in pageButtons.filter(item => item.enabled())"
            :key="button.id || index"
            v-bind="button"
            @click="handlePageButtonClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          direct="flex-end"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.pageIndex"
          @current-change="handlePaginationCurrentChange"
          :page-size.sync="pageInfo.pageSize"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { code } from '@/utils';
  import { commission } from '@/service/apis';
  import YkcDialog from '@/components/ykc-ui/dialog';
  // import HelpIcon from '@/views/financialManagement/accountReconciliationManagement/platformReceiptsPaymentsStatement/components/HelpIcon.vue';

  export default {
    name: 'PlatformFundFlowStatements',
    components: {},
    data() {
      return {
        flowTypes: [
          { name: '充电消费', id: '1' },
          { name: '占位费扣款', id: '2' },
          { name: '占位费退款', id: '3' },
          { name: '后台充值', id: '4' },
          { name: '后台扣款', id: '5' },
          { name: '上级分配', id: '6' },
          { name: '上级扣回', id: '7' },
          { name: '其它', id: '8' },
        ],
        id: '',
        dictionary: {},
        polymerizationInfo: {},
        pageTopButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        pageButtons: [
          {
            enabled: () => code('finance:reconci:capital:export'),
            id: '1',
            text: '导出',
            type: 'plain',
            handleClick: () => {
              this.doExportFile();
            },
          },
        ],
        tableData: [],

        tableColumns: [
          { label: '账单时间', prop: '0', minWidth: '100px' },
          { label: '充值金额', prop: '1', minWidth: '100px' },
          { label: '充值退款金额', prop: '2', minWidth: '100px' },
          { label: '订单消费金额', prop: '3', minWidth: '100px' },
          { label: '订单退款金额', prop: '4', minWidth: '100px' },
          { label: '抽成费用', prop: '5', minWidth: '100px' },
          { label: '运营商结算金额', prop: '6', minWidth: '100px' },

          // {
          //   label: '佣金金额(元)',
          //   prop: 'commissionAmount',
          //   minWidth: '100px',
          //   scopedSlots: {
          //     default: ({ row }) => {
          //       const title = row.commissionAmount ?? '——';
          //       return <span title={title}>{title}</span>;
          //     },
          //   },
          // },
        ],

        tableOperateButtons: [
          // {
          //   id: '1',
          //   text: '编辑',
          //   handleClick: (btn, { row }) => {
          //     this.$router.push({
          //       path: '/financeManage/agentCommissionApplication/edit',
          //       query: { id: row.id },
          //     });
          //   },
          // },
          // {
          //   id: '2',
          //   text: '明细',
          //   handleClick: (btn, { row }) => {
          //     this.$router.push({
          //       path: '/financialManagement/interconnectedBillingStatement/interconnectedBillingStatementsDetail',
          //       query: { id: row.id },
          //     });
          //   },
          // },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          userAccount: '',
          userName: '',
          phoneNumber: '',
          userId: '',
        },
        showDrawer: false,
        isEdit: false,
      };
    },
    created() {
      // this.searchTableList();
    },
    computed: {
      searchData() {
        return [
          // {
          //   comName: 'YkcDropdown',
          //   key: 'flowType',
          //   label: '流水类型',
          //   placeholder: '请选择',
          //   data: this.flowTypes,
          // },
          // {
          //   comName: 'YkcInput',
          //   key: 'phoneNumber',
          //   label: '流水时间',
          //   placeholder: '请输入流水时间',
          // },
          // {
          //   comName: 'YkcInput',
          //   key: 'turnOverAmount',
          //   label: '流水对象',
          //   placeholder: '请输入流水对象',
          // },
          {
            comName: 'YkcDatePicker',
            isDateType: true,
            key: '流水时间',
            change: this.handleChange,
            label: '流水时间',
          },
          // {
          //   comName: 'YkcInput',
          //   key: 'userAccount',
          //   label: '流量方名称',
          //   placeholder: '请输入流量方名称',
          // },
        ];
      },
    },
    methods: {
      handleChange(event, data) {
        console.log('event:', event);
        console.log('data:', data);
      },
      changeStateSearch() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      /** 根据条件查询数据 */
      searchTableList() {
        Promise.all([
          commission.list({
            ...this.pageInfo,
            body: this.searchParams,
          }),
          commission.polymerization(this.searchParams),
        ]).then(([res1, res2]) => {
          this.tableData = res1.body;
          this.pageInfo.total = res1.totalCount || 0;
          this.polymerizationInfo = res2.body;
        });
      },
      /** 导出文件 */
      doExportFile() {
        commission.export('代理人佣金列表', this.searchParams);
      },
      onAddDrawerClose(done) {
        done();
      },
      /** 点击抽屉取消按钮 callback */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            done();
            drawerDone();
            if (this.isEdit) {
              this.isEdit = false;
            }
          },
        });
      },
      /**
       * @desc 点击页面左上角按钮 callback
       * */
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, form);
        // if (form.createTime.length > 0) {
        //   [this.searchParams.createBeginTime, this.searchParams.createEndTime] = form.createTime;
        // }
        this.searchTableList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      /**
       * 重置 form data
       * */
      resetFormData() {
        this.ruleForm = {};
      },
    },
  };
</script>

<style scoped lang="scss">
  .card-info-area {
    box-sizing: border-box;
    .card-info {
      display: flex;
      box-sizing: border-box;
      flex-wrap: nowrap;
      flex-grow: 1;
      width: 892px;
      height: 125px;
      //line-height: 125px;
      background: #ffffff;
      box-shadow: 1px 1px 4px 1px rgba(94, 94, 94, 0.09);
      align-content: center;
      align-items: center;
    }
    .common-icon {
      display: inline-flex;
      box-sizing: border-box;
      width: 70px;
      height: 70px;
      margin-left: 30px;
      background: rgba(77, 140, 253, 0.1);
      border-radius: 14px;
      line-height: 70px;
      align-content: center;
      text-align: center;
      align-items: center;
      justify-content: center;
      .big-icon {
        width: 32px;
        height: 32px;
        display: inline-block;
        background-image: url('~@/assets/images/financial/customDriver/purse@2x.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
    .common-text {
      display: inline-flex;
      flex-direction: column;
      margin-left: 30px;
      .account-name {
        //width: 108px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 25px;
      }
      .purse-text {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
        //display: inline-flex;
        //align-items: center;
      }
      .purse-balance {
        //width: 261px;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        .purse-unit {
          width: 19px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
      }
    }
    .common-label-key {
      display: inline-block;
      width: 60px;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9b9b9b;
      line-height: 17px;
    }
    .common-label-val {
      display: inline-block;
      //width: 24px;
      //height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 17px;
      margin-left: 8px;
    }
    .white-stone {
      width: 16px;
      height: 125px;
    }
  }
</style>
